module.exports = __webpack_public_path__ + "img/logo.1a0430a3.png";